import { useEffect, useSyncExternalStore } from 'react';
let current = null;
const listeners = new Set();
const emit = () => listeners.forEach(fn => fn());
export function usePublishAskReport(label, route) {
  useEffect(() => {
    if (!label) return;
    const value = {label, route}; current = value; emit();
    return () => { if (current === value) {current = null; emit();} };
  }, [label, route]);
}
export function useAskReportContext() {
  return useSyncExternalStore(fn => {listeners.add(fn); return () => listeners.delete(fn);}, () => current, () => null);
}
